import React from 'react';
import PropTypes from 'prop-types';

import './MiniCommunityHeartIcon.scss';
import { constructCn } from '../../../utilities/helperFunctions';

const MiniCommunityHeartIcon = ({ className, isActive }) => {
    const cn = constructCn(
        'component-Icons-MiniCommunityHeartIcon',
        className,
        isActive && 'active',
        !isActive && 'inactive'
    );
    return (
        <svg
            className={cn}
            viewBox="0 0 30 30"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect id="Rectangle" x="0" y="0" width="30" height="30" />
                <g
                    id="mini-heart-fill"
                    transform="translate(5.000000, 7.000000)"
                >
                    <path
                        d="M15.7444797,0.146906579 C13.3584622,-0.494816649 10.4302946,1.23788858 9.68864794,3.70693008 C9.68864794,3.70688632 9.68860636,3.7067988 9.68860636,3.70671127 C9.06080331,1.12113206 5.91214167,-0.513809276 3.45552283,0.146906579 C0.998862404,0.807666197 -0.483724096,3.43932659 0.144037381,6.0249058 C0.771798857,8.61052877 4.22257434,11.3512436 9.28541369,15.7827836 C9.40528627,15.8876807 9.45987965,15.9392321 9.50977459,15.9697341 C9.56420165,16.0030368 9.63089455,16.0098637 9.68931321,15.985182 C9.74394817,15.9621195 9.78049621,15.9156882 9.91458885,15.7827836 C14.2723296,11.463974 18.4281621,8.61052877 19.0559652,6.0249058 C19.6837266,3.43932659 18.2010986,0.807666197 15.7444797,0.146906579"
                        id="Fill-4"
                    />
                </g>
            </g>
        </svg>
    );
};

MiniCommunityHeartIcon.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
};

MiniCommunityHeartIcon.defaultProps = {
    className: '',
    isActive: false,
};

MiniCommunityHeartIcon.displayName = 'MiniCommunityHeartIcon';

export default React.memo(MiniCommunityHeartIcon);
